import {
  getIndex
} from '@/api/courseCategory.api'

const state = {
  courseCategories: []
}

const mutations = {
  setCourseCategories (state, categories) {
    state.courseCategories = categories
  },
}

const getters = {
  courseCategories ({ courseCategories }) {
    return courseCategories
  },
}

const actions = {
  async fetchCourseCategory ({ state, commit }) {
    if (state.courseCategories.length) {
      return null
    }

    const categories = await getIndex()
    commit('setCourseCategories', categories)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
